import { render, staticRenderFns } from "./ktpMy.vue?vue&type=template&id=59291add&scoped=true"
import script from "./ktpMy.vue?vue&type=script&lang=ts"
export * from "./ktpMy.vue?vue&type=script&lang=ts"
import style0 from "./ktpMy.vue?vue&type=style&index=0&id=59291add&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59291add",
  null
  
)

export default component.exports